export function _uniqueName(pName, pNameList) {
  let _lName = pName;
  let _lCounter = 0;

  while(pNameList.includes(_lName)) {
    _lCounter += 1;
    _lName = pName + ' (' + _lCounter + ')';
  }
  return _lName;
}
